import Button from "react-bootstrap/Button";
import config from "../../config";
import Image from "react-bootstrap/Image";
import React from "react";

const HeaderSimplified = ({action}) => {
    const image_suffix = window.devicePixelRatio > 1 ? '@2x' : '';

    return (
        <div className="rebag-checkout__header">
            <div className='rebag-checkout__header-back-container'>
                <Button
                    className="rebag-checkout__back-button"
                    onClick={action}
                    variant="clean"
                    aria-label="Back"
                >
                    <span className="icon-chevron-left" />
                </Button>
            </div>
            <a href={config.host_rebag} className="rebag-checkout__logo-container">
                <Image
                    src={`${config.MEDIA_URL}/img/rebag-logo-black${image_suffix}.png`}
                    className="rebag-checkout__logo"
                    alt="Rebag.com"
                />
            </a>
            <Image
                alt="Rebag.com"
                src={`${config.MEDIA_URL}/img/shopify-secure.png`}
                className="rebag-checkout__shopify-secure"
            />
        </div>
    );
}

export default HeaderSimplified;